import _ from 'lodash';

export const back = flowState => {
  const { history } = flowState;
  const prevState = _.last(history);
  return prevState;
};

export const mapPayloadTo = field => payload => ({ [field]: payload });
